import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import keycloakPromise from 'utils/keycloak';

interface KeycloakContextValue {
  keycloak: any; // lub: ReturnType<typeof Keycloak> jeśli chcesz typowanie
  initialized: boolean;
}

const KeycloakContext = createContext<KeycloakContextValue>({
  keycloak: null,
  initialized: false,
});

export const useKeycloak = () => useContext(KeycloakContext);

export const KeycloakProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [keycloak, setKeycloak] = useState<any>(null);
  const [initialized, setInitialized] = useState(false);
  const didInit = useRef(false);

  useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;

    // 🚀 załaduj Keycloak dynamicznie
    keycloakPromise
      .then((instance) => {
        setKeycloak(instance);

        const msgHandler = (evt: MessageEvent) =>
        window.addEventListener('message', msgHandler);

        // 🧩 inicjalizacja po załadowaniu
        instance
          .init({
            onLoad: 'login-required',
            pkceMethod: 'S256',
            checkLoginIframe: false,
            flow: 'standard',
          })
          .then((authenticated) => {
            setInitialized(true);
          })
          .catch((err) => {
            console.error('Keycloak init failed:', err);
          });

        return () => window.removeEventListener('message', msgHandler);
      })
      .catch((err) =>
        console.error('❌ Nie udało się załadować Keycloak', err)
      );
  }, []);

  // 🔁 odświeżanie tokenu
  useEffect(() => {
    if (!initialized || !keycloak) return;

    const interval = setInterval(() => {
      if (!keycloak.authenticated || !keycloak.token) return;
      keycloak
        .updateToken(60)
        .then((refreshed: boolean) => {
          if (refreshed) console.log('🔄 Token odświeżony');
        })
        .catch(() => {
          console.warn('⚠️ Sesja wygasła – przekierowanie do logowania');
          keycloak.login();
        });
    }, 60000);

    return () => clearInterval(interval);
  }, [initialized, keycloak]);

  if (!initialized || !keycloak) {
    return null;
  }

  return (
    <KeycloakContext.Provider value={{ keycloak, initialized }}>
      {children}
    </KeycloakContext.Provider>
  );
};
